/**
 * Navigation helpers
 */

/**
 * Leave the app for an external url, e.g. the identity provider.
 * Kept in its own module so it can be stubbed in tests, as jsdom
 * does not implement navigation.
 */
export const redirectTo = (url: string) => {
  window.location.assign(url);
};

/**
 * Reload the app on the given url without adding an entry to the history.
 */
export const replaceWith = (url: string) => {
  window.location.replace(url);
};
